import React, { useState } from "react";
import { toast } from "sonner";
import { Copy, Check, LinkIcon, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

// invite = { name, token } | null
export default function InviteDialog({ invite, onClose }) {
  const [copied, setCopied] = useState(false);
  const link = invite ? `${window.location.origin}/set-password?token=${invite.token}` : "";

  const copy = () => {
    navigator.clipboard.writeText(link).then(() => {
      setCopied(true); toast.success("Bağlantı kopyalandı");
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Dialog open={!!invite} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#13131C] border-[#222230] text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-xl flex items-center gap-2"><Mail size={18} className="text-[#FF5500]" /> Şifre Belirleme Bağlantısı</DialogTitle>
          <DialogDescription className="text-[#A0A0B2]">
            <b className="text-white">{invite?.name}</b> hesabını oluşturdun. Bu bağlantıyı üyeyle paylaş; kendi şifresini belirleyip giriş yapabilir. (E-posta entegrasyonu eklendiğinde bu bağlantı otomatik gönderilecek.)
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-2 rounded-xl bg-[#0E0E14] border border-[#262636] p-2">
          <LinkIcon size={15} className="text-[#68687B] flex-shrink-0 ml-1" />
          <input data-testid="invite-link" readOnly value={link} onFocus={(e) => e.target.select()} className="text-xs text-[#A0A0B2] flex-1 font-mono bg-transparent outline-none truncate" />
        </div>
        <DialogFooter>
          <Button onClick={copy} data-testid="copy-invite-link" className="bg-[#FF5500] hover:bg-[#FF661A] text-white font-bold w-full">
            {copied ? <><Check size={16} className="mr-1" /> Kopyalandı</> : <><Copy size={16} className="mr-1" /> Bağlantıyı Kopyala</>}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
